module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/borders-selection-history.f7e9c5f2.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/borders-selection-history.png
// module id = 2832
// module chunks = 11